import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { REFECTH_QUERY_INTERVAL } from "@Constants/constant"
import { hasStartedSurvey } from "@Navigation/BottomTabBarStack/Logic"
import { currentDiagnosisAtom } from "@Recoil/Atom/DiagnosisAtom"
import { useQuery } from "@tanstack/react-query"

const { userAtom } = require("@Recoil/Atom/userAtom")
const { EducatifDiagnoseService } = require("@Services/EducatifDiagnose.Service")
const { useRecoilState } = require("recoil")

function useQueryDERQHooks() {
    const [user] = useRecoilState(userAtom)
    const [currentEducationalDiagnosis, setCurrentEducationalDiagnosis] = useRecoilState(currentDiagnosisAtom)

    return useQuery({
        queryKey: [`educational-diagnosis`],
        queryFn: async () => await EducatifDiagnoseService.getAlldiagnosis(user?.id),
        onSuccess: () => {},
        onError: () => {
            ShowToast({ type: "error", message: "Problème lors de la récuperation du DE" })
        },
        select: (responses) => {
            const data = responses?.data?.data
            setCurrentEducationalDiagnosis(data)
            return data
        },
        refetchInterval: REFECTH_QUERY_INTERVAL
    })
}

export { useQueryDERQHooks }
